import React from 'react'
import VerifyUser from '../../components/VerifyUser/VerifyUser'

const UserVerification = () => {
  return (
   <>

   <VerifyUser/>
   </>
  )
}

export default UserVerification
